import serverCall from "../../serverCall";
const CreateStanding = async (data) => {
  const response = await serverCall.post("/standing/create/admin", data);
  return response;
};

const getAllStanding = async (search, page, limit, type) => {
  const response = await serverCall.get(
    `/standing/find-all?search=${search}&page=${page}&limit=${limit}&type=${type}`
  );
  return response;
};

const GetSingleStanding = async (id) => {
  const response = await serverCall.get(`/standing/find-one?standingId=${id}`);
  return response;
};
const GetStandingUpdate = async (id, data) => {
  const response = await serverCall.patch(
    `/standing/update/admin?standingId=${id}`,
    data
  );
  return response;
};

const DeleteAllStanding = async (type) => {
  const response = await serverCall.delete(`/standing/admin?type=${type}`);
  return response;
};

const StandingService = {
  CreateStanding,
  getAllStanding,
  GetSingleStanding,
  DeleteAllStanding,
  GetStandingUpdate,
};

export default StandingService;
